import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectFailedAddProductToMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.addProductToMyWishlist.failed.map(
      (action): number => action.requestedActionId
    )
);

export default selectFailedAddProductToMyWishlistActionIds;
